import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { useTranslation } from 'react-i18next';

const whatsappNumber = '201099289280';
const whatsappUrl = `https://wa.me/${whatsappNumber}`;

export default function Contact() {
  const { t } = useTranslation();

  const contactLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    '@id': 'https://debugin.com/#organization',
    'name': 'Texio Technologies',
    'url': 'https://debugin.com',
    'description': 'AI-powered ERP platform built exclusively for textile factories, garment manufacturers, and dyeing houses.',
    'address': {
      '@type': 'PostalAddress',
      'streetAddress': 'Building 12, Dubai Internet City',
      'addressLocality': 'Dubai',
      'addressCountry': 'AE',
    },
    'contactPoint': [
      {
        '@type': 'ContactPoint',
        'contactType': 'sales',
        'email': 'sales@debugin.com',
        'telephone': '+20 109 9289 280',
        'availableLanguage': ['English', 'Arabic'],
        'areaServed': ['EG', 'TR', 'IN', 'BD', 'AE', 'PK', 'CN', 'VN', 'ID', 'TH', 'KH', 'LK'],
      },
      {
        '@type': 'ContactPoint',
        'contactType': 'customer support',
        'email': 'support@debugin.com',
        'availableLanguage': ['English', 'Arabic'],
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <title>Contact Texio - WhatsApp Us | AI Textile ERP Sales Team</title>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(contactLd) }}
      />

      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 pb-16 md:pb-24">
          <div className="w-full px-4 md:px-6 lg:px-10">
            <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 md:gap-16">
              <div>
                <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-foreground-950 mb-4">
                  Let&rsquo;s Talk
                </h1>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
                  Ready to see Texio in action? Message us on WhatsApp and our team will get back to you within hours with a personalized demo tailored to your factory needs.
                </p>

                <div className="space-y-5">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-whatsapp-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">WhatsApp</p>
                      <p className="text-xs text-foreground-600">+20 109 9289 280</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-mail-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">Email</p>
                      <p className="text-xs text-foreground-600">sales@debugin.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center shrink-0 mt-0.5">
                      <i className="ri-map-pin-line text-primary-600"></i>
                    </div>
                    <div>
                      <p className="text-sm font-semibold text-foreground-950">Office</p>
                      <p className="text-xs text-foreground-600">Dubai Internet City, Building 12<br />Dubai, United Arab Emirates</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center bg-white rounded-2xl border border-background-200/60 p-8 md:p-10">
                <div className="w-20 h-20 rounded-2xl bg-green-100 flex items-center justify-center mb-6">
                  <i className="ri-whatsapp-line text-green-600 text-3xl"></i>
                </div>

                <h2 className="text-xl md:text-2xl font-extrabold text-foreground-950 mb-2 text-center">
                  Message Us on WhatsApp
                </h2>
                <p className="text-sm text-foreground-600 text-center mb-8 max-w-xs">
                  Chat with our sales team directly.
                </p>

                <a
                  href={whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2.5 bg-green-500 text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-green-600 transition-all duration-200 cursor-pointer whitespace-nowrap w-full justify-center"
                >
                  <i className="ri-whatsapp-line text-xl"></i>
                  Start WhatsApp Chat
                </a>

                <p className="text-xs text-foreground-500 mt-6 text-center">
                  We typically respond within a few hours during business hours.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}